import React, { useState } from 'react';
import { Container, Form, Button, Alert } from 'react-bootstrap';
import { toUrl } from '../lib/config';

const HastaneCalisanlariGorusOneriPage: React.FC = () => {
  const [formData, setFormData] = useState({
    calisaninAdi: '',
    calistigiBirim: '',
    oneriGorusTarihi: new Date().toISOString().split('T')[0],
    gorusVeOnerileriniz: ''
  });

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    try {
      setLoading(true);
      setError('');
      setSuccess(false);

      const url = toUrl('/api/hastane-calisanlari-gorus-oneri');
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        throw new Error('Form gönderilemedi. Lütfen tekrar deneyin.');
      }

      setSuccess(true);
      setFormData({
        calisaninAdi: '',
        calistigiBirim: '',
        oneriGorusTarihi: new Date().toISOString().split('T')[0],
        gorusVeOnerileriniz: ''
      });

      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch (err: any) {
      setError(err.message || 'Bir hata oluştu. Lütfen tekrar deneyin.');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  return (
    <div className="anket-page">
      <Container className="py-5">
        <div className="text-center mb-5">
          <h6 className="text-muted mb-2">Bize ulaşın</h6>
          <h1 className="mb-3">
            İletişim
          </h1>
          <div style={{ 
            width: '60px', 
            height: '3px', 
            backgroundColor: '#f44336', 
            margin: '0 auto 20px' 
          }}></div>
          <p className="text-muted mb-3" style={{ maxWidth: '600px', margin: '0 auto 15px' }}>
            Megapark Hastanesi her an ve her zaman sizin yanınızda
          </p>
          <div style={{ 
            width: '100%', 
            height: '1px', 
            backgroundColor: '#ddd', 
            margin: '0' 
          }}></div>
        </div>

        <div className="mt-5">
          <h4 className="mb-2 fw-bold">Hastane Çalışanları Görüş ve Önerileri</h4>
          <div style={{ 
            width: '60px', 
            height: '3px', 
            backgroundColor: '#f44336', 
            marginBottom: '30px' 
          }}></div>

          {/* Başarı Mesajı */}
          {success && (
            <Alert variant="success" onClose={() => setSuccess(false)} dismissible>
              <Alert.Heading>Teşekkür Ederiz!</Alert.Heading>
              <p>
                Görüş ve öneriniz başarıyla gönderildi. Katkılarınız için teşekkür ederiz.
              </p>
            </Alert>
          )}

          {/* Hata Mesajı */}
          {error && (
            <Alert variant="danger" onClose={() => setError('')} dismissible>
              <Alert.Heading>Hata!</Alert.Heading>
              <p>{error}</p>
            </Alert>
          )}

          <Form onSubmit={handleSubmit} className="survey-form">
            {/* Çalışanın Adı Soyadı/Zorunda Değil */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                Çalışanın Adı Soyadı/Zorunda Değil
              </Form.Label>
              <Form.Control
                type="text"
                name="calisaninAdi"
                value={formData.calisaninAdi}
                onChange={handleChange}
                placeholder=""
                className="form-control-lg"
                style={{ backgroundColor: '#f5f5f5' }}
              />
            </Form.Group>

            {/* Çalıştığı Birim */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                Çalıştığı Birim
              </Form.Label>
              <Form.Control
                type="text"
                name="calistigiBirim"
                value={formData.calistigiBirim}
                onChange={handleChange}
                placeholder=""
                className="form-control-lg"
                style={{ backgroundColor: '#f5f5f5' }}
              />
            </Form.Group>

            {/* Öneri/Görüş Tarihi */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                Öneri/Görüş Tarihi
              </Form.Label>
              <Form.Control
                type="date"
                name="oneriGorusTarihi"
                value={formData.oneriGorusTarihi}
                onChange={handleChange}
                placeholder="gg.aa.yyyy"
                className="form-control-lg"
                style={{ backgroundColor: '#f5f5f5' }}
              />
            </Form.Group>

            {/* Görüş ve Önerileriniz */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                Görüş ve Önerileriniz
              </Form.Label>
              <Form.Control
                as="textarea"
                rows={8}
                name="gorusVeOnerileriniz"
                value={formData.gorusVeOnerileriniz}
                onChange={handleChange}
                placeholder=""
              />
            </Form.Group>

            {/* Submit Button */}
            <div className="text-center mt-4">
              <Button
                type="button"
                size="lg"
                disabled={loading}
                onClick={(e) => {
                  handleSubmit(e as any);
                }}
                style={{
                  backgroundColor: '#4CAF50',
                  borderColor: '#4CAF50',
                  fontWeight: '600',
                  padding: '12px 40px',
                  borderRadius: '25px'
                }}
              >
                {loading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    Gönderiliyor...
                  </>
                ) : (
                  'Gönder'
                )}
              </Button>
            </div>
          </Form>
        </div>
      </Container>
    </div>
  );
};

export default HastaneCalisanlariGorusOneriPage;
